exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".day-and-time-1{fill:#fbcfc8;}\n.day-and-time-2{fill:none;stroke:#014f6d;strokeLinecap:round;strokeLinejoin:round;strokeWidth:21px;}\n.day-and-time-3{fill:#014f6d;}", ""]);
